export default __webpack_public_path__ + "static/media/EM0740.34I-23430_-15267_0.8dbf0475.jpg";